import { ItemValidatorDto } from '@epicuro-next/data/engagement/document-control/models';

import { DocumentControlRuleType } from '../models';

export function isValidatorAvailableToUse(
  validators: ItemValidatorDto[],
  ruleToSearch: DocumentControlRuleType,
  contextToMatch?: string,
) {
  return validators.some(({ name, validatorContext }) => {
    const validatorContextValue = validatorContext.value;

    const contextResult = contextToMatch
      ? validatorContextValue === contextToMatch
      : validatorContextValue;

    return name === ruleToSearch && contextResult;
  });
}
